  <template>
  <b-container fluid>
    <div v-if="!isSAPKreditor">
      <h3>{{$t('Zulagen_BegruessungTitel')}}</h3>
      <p>{{$t('Zulagen_BegruessungText')}}</p>

      <b-btn @click="showModal" variant="primary">{{$t('Zulagen_BegruessungButton')}}</b-btn>
    </div>
    <div v-if="isSAPKreditor">
      <h3>{{$t('Zulagen_UebersichtTitel')}}</h3>
      <p>{{$t('Zulagen_UebersichtText')}}</p>
      <b-card :title="$t('Zulagen_UebersichtAdresseTitel')">
        <p>
          {{kreditor.name}}
          <br />
          {{kreditor.zusatz}}
          <br v-if="(kreditor.zusatz && kreditor.zusatz.length > 0)" />
          {{kreditor.strasse}} {{kreditor.hausnummer}}
          <br />
          {{kreditor.plz}} {{kreditor.ort}}
          <br />
          <br />
          {{kreditor.bank.name}}
          <br />
          {{iban4Blocks(kreditor.iban)}}
          <br />
        </p>
        <b-btn @click="showModalBearbeiten" variant="primary">{{$t('Zulagen_BearbeitenBtn')}}</b-btn>
      </b-card>
    </div>

    <!-- the modal -->
    <b-modal
      ref="myModal"
      id="myModal"
      :title="modalTitle"
      size="lg"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <div class="scroller">
        <div v-if="(tabIndex==0)">
          <p>
            <!-- this is a form text block (formerly known as help block) -->
            {{$t('Zulagen_IBANHilfeText')}}
          </p>
          <label for="inputLive">IBAN:</label>
          <b-form-input
            id="iban"
            v-model.trim="tmpZulagen.ibanEingabe"
            type="text"
            :state="ibanState"
            aria-describedby="ibanLiveHelp ibanLiveFeedback"
            placeholder="CHXX XXXX XXXX XXXX XXXX X"
          ></b-form-input>

          <b-form-invalid-feedback id="ibanLiveFeedback">
            <!-- This will only be shown if the preceeding input has an invalid state -->
            {{tmpZulagen.ibanError}}
          </b-form-invalid-feedback>

          <br />
          <label for="bcn">BCN:</label>
          <b-form-input id="bcn" v-model.trim="bcn" type="text" :disabled="true"></b-form-input>
          <br />

          <label for="bankName">{{$t('Zulagen_Bank')}}</label>
          <b-form-input id="bankName" v-model.trim="bank.name" type="text" :disabled="true"></b-form-input>
        </div>
        <div v-if="(tabIndex==1)">
          <p>{{$t('Zulagen_ZahlungsAdrHello')}}</p>
          <form @submit.prevent="addressOk()">
            <div class="row">
              <div class="col-12 col-lg-6">
                <p>
                  <b>{{$t('Zulagen_AdresseTitelStamm')}}</b>
                </p>
                <p>
                  {{adresse.name}} {{adresse.vorname}}
                  <br />
                  {{adresse.adresszusatz}}
                  <br v-if="(adresse.adresszusatz.length > 0)" />
                  {{adresse.zuhanden}}
                  <br v-if="(adresse.zuhanden.length > 0)" />
                  {{adresse.adresse}}
                  <br />
                  {{adresse.plz}} {{adresse.ort}}
                  <br />
                </p>
                <p>
                  <b-btn
                    @click="adresseKopieren"
                    variant="primary"
                    class="btn-wrap"
                  >{{$t('Zulagen_AdresseKopierenBtn')}}</b-btn>
                </p>
              </div>
              <div class="col-12 col-lg-6">
                <p>
                  <b>{{$t('Zulagen_AdresseTitelZahlung')}}</b>
                </p>
                <div class="row mb-3">
                  <div class="col-12 col-md-6">
                    <div role="group">
                      <label for="name">{{$t('Name')}}</label>

                      <b-form-input
                        id="name"
                        v-model.trim="tmpZulagen.name"
                        type="text"
                        :state="nameState"
                        aria-describedby="inputLiveHelpName"
                      ></b-form-input>
                      <b-form-text id="inputLiveHelpName">{{$t('Zulagen_AdresseNameToolTip')}}</b-form-text>
                    </div>
                  </div>

                  <div class="col-12 col-md-6">
                    <label for="vorname">{{$t('Vorname')}}</label>
                    <b-form-input
                      id="vorname"
                      v-model.trim="tmpZulagen.vorname"
                      type="text"
                      :state="vornameState"
                    ></b-form-input>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="zusatz">{{$t('Zusatz')}}</label>
                  <b-form-input
                    id="zusatz"
                    v-model.trim="tmpZulagen.zusatz"
                    type="text"
                    :state="zusatzState"
                  ></b-form-input>
                </div>
                <div class="row mb-3">
                  <div class="col-8">
                    <div role="group">
                      <label for="strasse">{{$t('Strasse')}}</label>
                      <b-form-input
                        id="strasse"
                        v-model.trim="tmpZulagen.strasse"
                        type="text"
                        :state="strasseState"
                        aria-describedby="inputLiveHelpStrasse"
                      ></b-form-input>
                      <b-form-text id="inputLiveHelpStrasse">{{$t('Zulagen_AdresseStrasseToolTip')}}</b-form-text>
                    </div>
                  </div>
                  <div class="col-4">
                    <div role="group">
                      <label for="hausnummer">{{$t('Zulagen_AdresseHausNr')}}</label>
                      <b-form-input
                        id="hausnummer"
                        v-model.trim="tmpZulagen.hausnummer"
                        type="text"
                        :state="hausnummerState"
                        aria-describedby="inputLiveHelpHausNr"
                      ></b-form-input>
                      <b-form-text id="inputLiveHelpHausNr">{{$t('Zulagen_AdresseHausNrToolTip')}}</b-form-text>
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-4">
                    <label for="plz">{{$t('Zulagen_AdressePLZ')}}</label>
                    <b-form-input
                      id="plz"
                      v-model.trim="tmpZulagen.plz"
                      type="text"
                      :state="plzState"
                    ></b-form-input>
                  </div>
                  <div class="col-8">
                    <label for="ort">{{$t('Ort')}}</label>
                    <b-form-input
                      id="ort"
                      list="ortList"
                      name="ort"
                      v-model.trim="tmpZulagen.ort"
                      type="text"
                      :state="ortState"
                    ></b-form-input>
                    <datalist id="ortList">
                      <option v-for="(value, key) in orte" v-bind:key="key">{{value.ort}}</option>
                    </datalist>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <b-form-checkbox
                  id="AdresseAGB"
                  v-model="tmpZulagen.abgChecked"
                  :state="agbState"
                >{{$t('Zulagen_ZahlungsAdrAGB')}}</b-form-checkbox>
              </div>
            </div>
          </form>
        </div>
        <div v-if="(tabIndex==2)">
          <p>{{$t('Zulagen_ZahlungsAbschlussTxt')}}</p>

          <div class="row">
            <div class="col-12 col-lg-6">
              <p>
                <b>{{$t('IBAN')}}</b>
                <br />
                {{iban4Blocks(tmpZulagen.iban)}}
              </p>
            </div>

            <div class="col-12 col-lg-6">
              <b>{{$t('Adresse')}}</b>
              <p>
                {{tmpZulagen.name}} {{tmpZulagen.vorname}}
                <br />
                {{tmpZulagen.zusatz}}
                <br />
                {{tmpZulagen.strasse}}&nbsp;{{tmpZulagen.hausnummer}}
                <br />
                {{tmpZulagen.plz}}&nbsp;{{tmpZulagen.ort}}
                <br />
              </p>
            </div>
          </div>
          <p>{{$t('Zulagen_ZahlungsAbschlussUnten').replace('XXXX',domain.email)}}</p>
        </div>
        <div v-if="(tabIndex==3)">
          <p v-if="(sendStatus==0)">warte auf versand ..</p>
          <p v-if="(sendStatus==1)">{{$t('Zulagen_SAPsendInProgress')}}</p>

          <b-alert v-if="(sendStatus==2)" show variant="success">{{$t('Zulagen_SAPsendOk')}}</b-alert>
          <div v-if="(sendStatus==3)">
            {{$t('Zulagen_SAPsendError')}}
            <b-alert
              v-for="(value, key) in sapMeldungen"
              show
              variant="danger"
              v-bind:key="key"
            >{{ value }}</b-alert>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <b-btn
          @click="tabsZurueck"
          v-if="zurueckBtnShow"
          :disabled="zurueckBtnDisabled"
        >{{zurueckBtn.name}}</b-btn>
        <b-btn @click="hideModal" v-if="abbrechenBtnShow">{{abbrechenBtn.name}}</b-btn>
        <b-btn
          id="weiterBtn"
          @click="tabsWeiter"
          v-if="weiterBtnShow"
          variant="primary"
        >{{$t("Weiter")}}</b-btn>
        <b-popover
          target="weiterBtn"
          triggers="hover click"
          v-if="!weiterBtnEnabled"
        >{{ weiterTooltip }}</b-popover>
        <b-btn
          @click="hideModal"
          v-if="schliessenBtnShow"
          variant="primary"
        >{{$t("Zulagen_ModalSchliessenBtn")}}</b-btn>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { axios, i18n, apiURL } from "../main";

// https://www.npmjs.com/package/iban
import IBAN from "iban";

export default {
  name: "zulagen",
  data() {
    return {
      tabIndex: 0,
      zurueckBtn: { show: true, name: this.$t("back") },
      abbrechenBtn: { show: true, name: this.$t("Abbrechen") },
      sendStatus: 0, // 0 idle, 1 sending, 2 done, 3 errror
      sapMeldungen: [],
      bcn: "", //lokale BCN info
      bank: { name: "", bcnr: "" }, // remote BANK INFO
      // im Modalen Dialog sind die Daten nicht persistent.
      tmpZulagen: {
        kreditor: "",
        iban: "CH", //"CH8800767000L06546550"', //irgendeine vom BUND CH8800767000L06546550 invalid im SAP....   Martin: CH4681377000004867580
        ibanEingabe: "",
        ibanError: "",
        name: "",
        vorname: "",
        zusatz: "",
        strasse: "",
        hausnummer: "",
        plz: "",
        ort: "",
        abgChecked: false
      },
      orte: []
    };
  },
  computed: {
    adresse() {
      return this.$store.state.userStore.adresse;
    },
    domain() {
      return this.$store.state.userStore.domain;
    },
    kreditor() {
      return this.$store.state.zulagenStore.kreditor;
    },
    fielddef() {
      return this.$store.state.zulagenStore.fielddef;
    },
    isSAPKreditor() {
      if (typeof this.kreditor.kreditor == "undefined") return false;
      if (this.kreditor.kreditor == "") return false;
      if (this.kreditor.kreditor.length > 0) return true;
      return true;
    },

    ibanState() {
      return this.tmpZulagen.ibanError.length == 0 ? true : false;
    },
    modalTitle() {
      if (this.tabIndex === 0) {
        return this.$t("Zulagen_PopupZVTitle");
      }
      if (this.tabIndex === 1) {
        return this.$t("Zulagen_PopupZVTitleAdress");
      }
      if (this.tabIndex === 2) {
        return this.$t("Zulagen_PopupZVTitleAbschluss");
      }
      if (this.tabIndex === 3) {
        return this.$t("Zulagen_Datenübermittlung");
      }
      return this.$t("Zulagen_PopupZVTitle");
    },
    //i'll validate the name
    nameState() {
      /* name +" "+ vorname between 1, 40 */
      if (
        this.tmpZulagen.name.length >= 1 &&
        this.tmpZulagen.name.length + this.tmpZulagen.vorname.length <= 39
      ) {
        return true;
      }
      return false;
    },
    vornameState() {
      /* name +" "+ vorname between 1, 40 */
      return this.tmpZulagen.name.length + this.tmpZulagen.vorname.length >=
        this.min("name") &&
        this.tmpZulagen.name.length + this.tmpZulagen.vorname.length <=
          this.max("name")
        ? true
        : false;
    },
    zusatzState() {
      return this.tmpZulagen.zusatz.length >= this.min("zusatz") &&
        this.tmpZulagen.zusatz.length <= this.max("zusatz")
        ? true
        : false;
    },
    //i'll validate the strasse
    strasseState() {
      return this.tmpZulagen.strasse.length >= this.min("strasse") &&
        this.tmpZulagen.strasse.length <= this.max("strasse")
        ? true
        : false;
    },
    hausnummerState() {
      return this.tmpZulagen.hausnummer.length >= this.min("hausnummer") &&
        this.tmpZulagen.hausnummer.length <= this.max("hausnummer")
        ? true
        : false;
    },
    plzState() {
      if (typeof parseInt(this.tmpZulagen.plz) != "number") return false;

      //im schweizer range
      if (this.tmpZulagen.plz < 999 || this.tmpZulagen.plz > 9999) return false;

      //für die Plz konnte ein Ort aufgelöst werden
      return this.orte.length > 0 ? true : false;
    },
    ortState() {
      if (
        this.tmpZulagen.ort.length >= this.min("ort") &&
        this.tmpZulagen.ort.length <= this.max("ort")
      ) {
        return true;
      }
      return false;
    },
    agbState() {
      return this.tmpZulagen.abgChecked;
    },
    weiterBtnEnabled() {
      if (this.tabIndex === 0) {
        return this.ibanState == true ? true : false; // null = false
      }
      if (this.tabIndex === 1) {
        return (
          this.nameState &&
          this.strasseState &&
          this.plzState &&
          this.ortState &&
          this.agbState
        );
      }
      return true;
    },
    weiterTooltip() {
      if (this.tabIndex == 0) return this.$t("Zulagen_weiterBtnTooltipIBAN");
      if (this.tabIndex == 1) return this.$t("Zulagen_weiterBtnTooltipAdresse");
      return "";
    },
    weiterBtnShow() {
      // immer zeigen ausser bei tab3 und sendestatus != gesendet
      return this.tabIndex < 3 ? true : false;
    },
    zurueckBtnDisabled() {
      if (this.tabIndex == 3 && [0, 1].includes(this.sendStatus)) {
        return true;
      }
      return false;
    },
    zurueckBtnShow() {
      if (this.tabIndex == 0) {
        return false;
      }
      if (this.tabIndex == 3 && [2].includes(this.sendStatus)) {
        return false;
      } //sendeStatus 0 idle, 1 sending, 2 done, 3 errror
      return true;
    },
    abbrechenBtnShow() {
      if (this.tabIndex == 3 && [0, 1, 2].includes(this.sendStatus)) {
        return false;
      } //sendeStatus 0 idle, 1 sending, 2 done, 3 errror
      return true;
    },
    schliessenBtnShow() {
      if (this.tabIndex == 3 && this.sendStatus == 2) {
        return true;
      } //sendeStatus 0 idle, 1 sending, 2 done, 3 errror
      return false;
    }
  },
  methods: {
    min(fielName) {
      return this.fielddef.filter(defs => defs.name == fielName)[0].min;
    },
    max(fielName) {
      return this.fielddef.filter(defs => defs.name == fielName)[0].max;
    },
    iban4Blocks(val) {
      return val
        .replace(/[^\dA-Z]/g, "")
        .replace(/(.{4})/g, "$1 ")
        .trim();
    },
    async setBankByIBAN(iban) {
      if (typeof iban != "string") throw "iban ist undenied?";
      if (iban.length < 7) throw "iban zu kurz";

      try {
        var bank = await axios.get(
          apiURL + "zulagen.cfc?method=getBankByIban",
          { params: { iban: iban, locale: i18n.locale } }
        );
        //var analysen = await axios.get(apiURL + 'analysen.cfc?method=getData', {  params: { btrids: betriebSelected,locale:i18n.locale }  })  //immer alle
        this.bank = bank.data;
      } catch (e) {
        /* #862 keinen Fehler anzeigen .. 
        bus.$emit(
          "error",
          "Bankinformationen konnten nicht geladen werden .." +
            JSON.stringify(e.message)
        );
        */
      }
    },
    async setKreditor(kreditor) {
      this.sendStatus = 1;
      this.sendMessage = "";
      try {
        await this.$store.dispatch("setKreditor", kreditor);
        this.sendStatus = 2;
        await this.$store.dispatch("loadZulagen");
        // für das Profil den Kreditor updaten
        this.$store.commit("setDomainKreditor", {
          kreditor: this.kreditor.kreditor
        });
      } catch (e) {
        this.sendStatus = 3;
        if (!Array.isArray(e.response.data) && e.response.data.length > 10) {
          this.sapMeldungen = ["Coldfusion Error:" + e.response.statusText];
        } else {
          this.sapMeldungen = e.response.data;
        }
      }
    },
    adresseKopieren() {
      //Kopiert die StammdatenAdresse
      this.tmpZulagen.name = this.adresse.name;
      this.tmpZulagen.vorname = this.adresse.vorname;

      this.tmpZulagen.zusatz =
        this.adresse.adresszusatz.length > 0
          ? this.adresse.adresszusatz.toString()
          : this.adresse.zuhanden.toString();
      //this.adresse.adresse= 'abc'
      let testHausNummer = this.adresse.adresse.match(/\s\d+\w{0,1}/g);
      if (testHausNummer != null) {
        this.tmpZulagen.hausnummer = testHausNummer[0];
        this.tmpZulagen.strasse = this.adresse.adresse.substring(
          0,
          this.adresse.adresse.length - this.tmpZulagen.hausnummer.length
        );
      } else {
        this.tmpZulagen.strasse = this.adresse.adresse;
      }
      this.tmpZulagen.plz = this.adresse.plz;
      this.tmpZulagen.ort = this.adresse.ort;
    },
    showModal() {
      this.$refs.myModal.show();
      this.tabIndex = 0;
      this.zurueckBtn.show = false;
    },
    showModalBearbeiten() {
      // Feld für Feld sonst wird die Referenz kopiert und vueJs hat Mühe mit den computed Props
      this.tmpZulagen.name = this.kreditor.name;
      this.tmpZulagen.vorname = "";
      this.tmpZulagen.zusatz =
        typeof this.kreditor.zusatz == "undefined" ? "" : this.kreditor.zusatz;
      this.tmpZulagen.strasse = this.kreditor.strasse;
      this.tmpZulagen.hausnummer = this.kreditor.hausnummer;
      this.tmpZulagen.plz = this.kreditor.plz;
      this.tmpZulagen.ort = this.kreditor.ort;
      this.tmpZulagen.iban = this.kreditor.iban;
      this.tmpZulagen.ibanEingabe = this.iban4Blocks(this.kreditor.iban);
      this.$refs.myModal.show();
      this.tabIndex = 0;
      this.zurueckBtn.show = false;
    },
    hideModal() {
      this.$refs.myModal.hide();
    },
    tabsZurueck() {
      this.tabIndex--;
      if (this.tabIndex == 0) {
        this.zurueckBtn.show = false;
      }
      document.getElementsByClassName("modal").myModal.scrollTo({ top: 0 }); // #844 immer nachoben scrollen
    },
    tabsWeiter() {
      if (this.weiterBtnEnabled) {
        this.tabIndex++;
        this.zurueckBtn.show = true;
        if (this.tabIndex == 3) {
          this.setKreditor(this.tmpZulagen);
        }
        document.getElementsByClassName("modal").myModal.scrollTo({ top: 0 }); // #844 immer nachoben scrollen
      }
    }
  },
  watch: {
    "tmpZulagen.ibanEingabe": function(newVal) {
      // hübsch formatieren
      this.tmpZulagen.iban = newVal.replace(/\s/gi, "");

      // Bank  Laden
      if (this.tmpZulagen.iban.length >= 9) {
        if (this.bcn != this.tmpZulagen.iban.substring(4, 9)) {
          this.bcn = this.tmpZulagen.iban.substring(4, 9);
          this.setBankByIBAN(this.tmpZulagen.iban);
        }
      }

      // Fehlermeldungen generieren
      if (this.tmpZulagen.iban.substring(0, 2) != "CH") {
        this.tmpZulagen.ibanError = this.$t("Zulagen_IBANnurLaender");
      } else if (this.tmpZulagen.iban.length < 21) {
        // CH == 21 https://de.wikipedia.org/wiki/Internationale_Bankkontonummer
        this.tmpZulagen.ibanError = this.$t("Zulagen_IBANzuKurz");
      } else if (this.tmpZulagen.iban.length > 21) {
        this.tmpZulagen.ibanError = this.$t("Zulagen_IBANzuLang");
      } else if (!IBAN.isValid(this.tmpZulagen.iban)) {
        this.tmpZulagen.ibanError = this.$t("Zulagen_IBANungueltig");
      } else {
        this.tmpZulagen.ibanError = "";
      }
    },
    "tmpZulagen.plz": async function(newVal) {
      if (newVal >= 1000) {
        //getOrtByPLZ(newVal)
        var getOrtByPLZ = await axios.get(
          apiURL + "public.cfc?method=getOrtByPLZ",
          { params: { plz: newVal, locale: i18n.locale } }
        ); //immer alle
        this.orte = getOrtByPLZ.data;
        if (this.tmpZulagen.ort == null && this.orte.length == 1) {
          this.tmpZulagen.ort = this.orte[0].ort;
        }
      }
    }
  },
  created() {
    let self = this;
    this.$nextTick(async function() {
      if (this.$store.state.userStore.domain.modules === "ZVM") {
        await self.$store.dispatch("loadZulagen");
        if (!this.isSAPKreditor) this.showModal();
      } else self.$store.dispatch("loadZulagen");
    });
  },
  mounted() {},
  updated() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* div.scroller{ width:100%; height: 100%; overflow-z: auto;} */
</style>
